import React from 'react';

import { useStateValue } from '../context/state.jsx';

const ConnectivityVisual = () => {
	const [{ isOnline }] = useStateValue();

	let connectivityClass = 'offline';
	let connectivityString = 'Offline';
	if (isOnline) {
		connectivityClass = 'online';
		connectivityString = 'Online';
	}

	return (
		<div className={`connectivityVisual ${connectivityClass}`}>
			<span className="glyphicon glyphicon-record leftGlyph"></span>
			<span>{connectivityString}</span>
		</div>
	);
};

export default ConnectivityVisual;